import React, {Component, ReactNode} from 'react';
import GridLoader from 'react-spinners/GridLoader';
// For other loaders : https://www.davidhu.io/react-spinners/
class AppLoader extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render(): ReactNode {
    return (
      <div className="flex-centering">
        <GridLoader size={15} margin={5} color={'#007bff'} />
      </div>
    );
  }
}

export default AppLoader;
